import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import GoogleSignInButton from '../../components/ui/GoogleSignInButton';
import { Shield, Loader2 } from 'lucide-react';

const AdminLogin = () => {
  const { login, error, user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect to dashboard if already logged in
  useEffect(() => {
    if (user && !loading) {
      const from = location.state?.from?.pathname || '/admin';
      navigate(from, { replace: true });
    }
  }, [user, loading, navigate, location]);

  // Show loading while checking auth
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-[#C8473A] mx-auto mb-4" />
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          {/* Logo */}
          <div className="text-center mb-8">
            <img
              src="/images/yournest-logo-admin.png"
              alt="YourNest"
              className="h-12 mx-auto mb-4 object-contain"
            />
            <h1 className="text-2xl font-bold text-[#211F1F]">Admin Portal</h1>
            <p className="text-gray-500 mt-2">Sign in to manage your content</p>
          </div>

          {/* Error Message */}
          {error && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
              {error}
            </div>
          )}

          {/* Official Google Sign-In button (renders Google's UI, width matches container) */}
          <div className="mt-4 w-full min-w-0">
            <GoogleSignInButton containerId="google-signin-visible" className="w-full min-w-0" />
          </div>

          {/* Info */}
          <div className="mt-8 p-4 bg-gray-50 rounded-lg">
            <div className="flex items-start gap-3">
              <Shield className="w-5 h-5 text-[#C8473A] flex-shrink-0 mt-0.5" />
              <div className="text-sm text-gray-600">
                <p className="font-medium text-gray-700">Secure Access</p>
                <p className="mt-1">
                  Only authorized team members can access the admin portal. 
                  Contact your administrator if you need access.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-gray-400 text-sm mt-6">
          © {new Date().getFullYear()} YourNest Venture Capital
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
